/* import __COLOCATED_TEMPLATE__ from './product-navigation-logo.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {};
}

const ProductNavigationLogo = templateOnlyComponent<Signature>();
export default ProductNavigationLogo;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::ProductNavigationLogo': typeof ProductNavigationLogo;
  }
}
